<template>
  <div>
    <b-card>
      <b-row class="mb-1">
        <b-col class="4">
          <month-picker-input :no-default="true" placeholder="Cari Period" @change="DateChange"></month-picker-input>
        </b-col>
        <b-col class="text-right">
          <b-button @click="AddCountSalary()" variant="primary" v-ripple.400="'rgba(255, 255, 255, 0.15)'">
            Tambah
          </b-button>
        </b-col>
      </b-row>
      <BaseTable
        :fields="fields"
        :items="items"
        :loading="loading"
        :rows="pagination.total"
        :perPage="filter.size"
        :currentPage="filter.page"
        :detail-item="ViewPayroll"
        :handle-page-change="handlePageChange"
        :edit-item="EditCountSalary"
        :delete-item="deleteItem"
      />

      <CalculationSalaryForm
        pageTitle="Tambah Perhitungan Gaji"
        :editId="editId"
        :get-data="getCalculationSalary"
        :formPayload="formPayload"
      />

    </b-card>
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormInput } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import InputText from "@/components/InputText.vue";
import InputTextArea from "@/components/InputTextArea.vue";
import InputFile from "@/components/InputFile.vue";
import CalculationSalaryForm from '../../components/CalculationSalary/CalculationSalaryForm';
import { GetManualSalaryService } from '../../services/master_manual_salary.service';
import { successNotification, errorNotification } from "@/auth/utils";
import utility from '../../libs/utility';
import { MonthPickerInput } from 'vue-month-picker'
export default {
  name: "CalculateSalary",
  components: {
    BaseTable,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    CalculationSalaryForm,
    InputText,
    InputTextArea,
    InputFile,
    MonthPickerInput
  },
  setup() {
    return {
      BaseTable,
    }
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      pageTitle: 'Master Transport',
      fields: [
        {
          key: "no",
          label: "No"
        },
        {
          key: "period",
          label: "Periode"
        },
        {
          key: "progressAbsent",
          label: "Hitung Absensi"
        },
        {
          key: "progressOvertime",
          label: "Hitung Lembur"
        },
        {
          key: "progressPayroll",
          label: "Hitung Gaji"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "actions",
          label: "Aksi"
        }
      ],
      items: [],
      loading: false,
      periode: '',
      pagination: {
        total: 0
      },
      filter: {
        title: "",
        page: 1,
        size: 10
      },
      editId: null,
      formPayload: Object
    }
  },
  watch: {
    'filter.page': function () {
      this.getCalculationSalary();
    }
  },
  methods: {
    handlePageChange(value) {
      this.loading = true
      this.filter.page = value;
    },
    DecodeStatus(status) {
      if (status) {
        return 'Selesai';
      }
      if (!status) {
        return 'Progress';
      }
    },
    AddCountSalary() {
      this.editId  =  null;
      this.formPayload = {
        periodeSalary: "",
        startDate: "",
        endDate: "",
        salaryIncreasePeriod: null
      }
      this.$bvModal.show('form-calculation-salary');
    },
    ViewPayroll(items) {
      return this.$router.push(`/calculate-salary/view/${items.payslipId}`);
    },
    EditCountSalary(items) {
      window.console.log(items);
      this.editId  =  items.payslipId;
      this.formPayload = {
        salaryIncreasePeriod: {
          text: items.isUpload ? 'Ya': 'Tidak',
          value: items.isUpload
        },
        startDate: items.startDate,
        periodeSalary: items.period,
        endDate: items.endDate
      };
      this.$bvModal.show('form-calculation-salary');
    },
    deleteItem (items) {
      window.console.log(items);
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        window.console.log(result);
        if (result.isConfirmed) {
          await GetManualSalaryService.delete(items.payslipId)
            .then((result) => {
              window.console.log(result);
              if (result.code === "00") {
                successNotification(this, "Success",result.message);
                this.getCalculationSalary();
              }
            })
            .catch((e) => {
              errorNotification(this, "Oops!", e.message);
            });
        }
      });
    },
    async getCalculationSalary() {
      this.loading = true;
      let req = {
        size: this.filter.size,
        page: this.filter.page,
        isUpload: false
      };
      if (this.periode !== '') {
        req['period'] = this.periode;
      }
      this.items = [];
      await GetManualSalaryService.find(req)
        .then((result) => {
          if (utility.ResponseCode02(result)) {
            // window.console.log(result);
            // let no = 1;
            result.data.content.forEach((item) => {
              item['no'] = item.no;
              item['progressAbsent'] = this.DecodeStatus(item.progressCalculateAttendance);
              item['progressOvertime'] = this.DecodeStatus(item.progressCalculateOvertime);
              item['progressPayroll'] = this.DecodeStatus(item.progressCalculatePayroll);
              this.items.push(item);
            });
            this.pagination.total = result.data.total;
          }
          this.loading = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.loading  =  false;
        });
    },
    DateChange(time) {
      window.console.log(time);
      let numberIndex = `${time.monthIndex}`;
      if (time.monthIndex <= 9) {
        numberIndex   =  `0${time.monthIndex}`;
      }
      window.console.log(numberIndex);
      this.periode = `${time.year}-${numberIndex}`;
      this.getCalculationSalary();
    }
  },
  mounted() {
    this.getCalculationSalary();
  }
}
</script>
